import {
  type CancelFlowVersion,
  getCancelFlowVersionFromUser,
} from "../../../Common/utils/cancelFlowVersion";

export const resolveWebCancelFlowVersion = (
  user: { createdDt?: number } | null | undefined,
): CancelFlowVersion => getCancelFlowVersionFromUser(user);
